var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-cart d-flex align-items-center justify-content-center mt-5"},[_c('img',{attrs:{"src":require('@/assets/images/error/image-empty.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }